import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { Gender } from "@/Common/Models/Patient/PatientEnums";
import { Person } from "@/Common/Models/Person/Person";
import * as ServerOperations from "@/Common/Operations/operations.server";

import img_loading from "@/Globals/_images/loading.gif";
import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IApexExternalSearchPopup {
    onCloseCallback: () => void;
    person: Person;
}

class ApexPatientrequest {
    public nom: string; // var nom = "FERNANDO2TEST";
    public paterno: string; // var Paterno = "MORALES2TEST";
    public materno: string; // var materno = "PALLESTEROS";
    public DDN: Date; // var DDN = "21/02/1987";
    public sex: ApexGenderEnum; // var sex = "M";
    public rfc: string; // var rfc = "MOPF870221";
    public curp: string; // var curp = "MOPF870221";
}

class ChristusSendApexResponse {
    public IsSuccess: boolean;
    public RawResponse: string;
    public IsProxyError: boolean;
    public ApexMessage: string;
    public ApexReturnCode: string;
    public Patients: ApexPatientResponse[];
}

class ApexPatientResponse {
    public ID_PERSONA: string;
    public NOMBRE: string;
    public SEGUNDO_NOMBRE: string;
    public APELLIDO_PATERNO: string;
    public APELLIDO_MATERNO: string;
    public FECHA_NAC: string; // Date
    public SEXO: ApexGenderEnum;
    public RFC: string;
    public CURP: string;
    public PAIS: string;
    public DESC_PAIS: string;
    public ESTADO: string;
    public DESC_ESTADO: string;
    public CODIGO_POSTAL: string;
}

enum ApexGenderEnum {
    M,
    F
}

class ApexExternalSearchPopupState {
    public isLoading: boolean;
    public selectedPatientId: string;
    public apexPatientResult: ApexPatientResponse[];
    public apexRequest: ApexPatientrequest;
}

class ApexExternalSearchPopup extends React.Component<IApexExternalSearchPopup, ApexExternalSearchPopupState> {
    private componentId: string;

    public componentWillMount(): void {
        this.componentId = "ApexExternalSearchPopup_" + sessionStore.newId();

        const s = new ApexExternalSearchPopupState();
        s.isLoading = true;

        let pp = this.props.person;
        let apexPatientRequest = new ApexPatientrequest();
        apexPatientRequest.curp = pp.NAM;
        apexPatientRequest.rfc = pp.NAM;
        apexPatientRequest.DDN = pp.DateofBirth;
        apexPatientRequest.nom = pp.FirstName;
        apexPatientRequest.sex = pp.gender == Gender.Female ? ApexGenderEnum.F : ApexGenderEnum.M;
        apexPatientRequest.materno = pp.motherLastName;
        apexPatientRequest.paterno = pp.fatherLastName;
        if (IsNullOrWhiteSpace(apexPatientRequest.materno) && pp.LastName && pp.LastName.split(" ").length == 2) {
            apexPatientRequest.materno = pp.LastName.split(" ")[1];
        }
        if (IsNullOrWhiteSpace(apexPatientRequest.paterno) && pp.LastName && pp.LastName.split(" ").length == 2) {
            apexPatientRequest.paterno = pp.LastName.split(" ")[0];
        }

        s.apexRequest = apexPatientRequest;

        this.setState(s, () => {
            Client.Post(
                ServerOperations.Server.MYLE_ChristusApexProxySearchPatient,
                { apexPatient: apexPatientRequest },
                (response, err) => {
                    let responseApex = response as ChristusSendApexResponse;
                    let pp = [] as ApexPatientResponse[];

                    if (responseApex.IsProxyError == true) {
                        sessionStore.showPopup({
                            title: responseApex.ApexReturnCode,
                            content: responseApex.ApexMessage
                        });
                    }
                    else if (responseApex.IsSuccess != true)
                        sessionStore.showPopup(err);
                    else
                        pp = responseApex.Patients;

                    this.mutateState(s => {
                        s.isLoading = false;
                        s.apexPatientResult = pp;
                    });
                }
            );
        });
    }

    public componentDidMount(): void {
        var elem = $("#" + this.componentId);
        const cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".p-header",
            stop: () => {
                elem.draggable("destroy");
                window.setTimeout(() => {
                    elem.draggable(dragOptions);
                }, 80);
            }
        };
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public render(): JSX.Element {
        return (
            <div className="patient-sync-control" id={this.componentId}>
                <div className="pps-header flex-container p-header">
                    <h4>{cacheStore.GetString("PortalPatientSearchAttachFileLabel")}</h4>
                    <span onClick={() => this.props.onCloseCallback()} className="glyphicon glyphicon-remove pointer" />
                </div>
                <div className="pps-main">
                    <div className="flex-container split">
                        {this.renderLeft()}
                        {this.renderRight()}

                    </div>
                </div>

                <div className="pps-footer flex-container">
                    <button onClick={() => this.props.onCloseCallback()} className="btn btn-default push-right-5"><span>{cacheStore.GetString("CancelLabel")}</span></button>
                    <button onClick={() => this.onAttachAccountClick()} disabled={this.state.isLoading || !this.state.selectedPatientId} className="btn btn-primary"><span>{cacheStore.GetString("AttachLabel")}</span></button>
                </div>

            </div>
        );
    }

    private renderLeft(): JSX.Element {
        let person = this.props.person;

        return (
            <div className="patient-view" style={{ minHeight: "400px" }}>
                <div className="flex-container patient psr">
                    <div className="logo"><img src={img_p_banner_icon_100} alt="MYLE" style={{ width: "48px" }} /></div>
                    <div className="demographics">
                        <div> {person.prefix} {person.LastName.toUpperCase()}, {person.FirstName}</div>
                        <div><strong>Paterno </strong><span>{this.state.apexRequest.paterno}</span></div>
                        <div><strong>Materno </strong><span>{this.state.apexRequest.materno}</span></div>
                        <div><span>CURP: </span><strong> {person.NAM} </strong></div>
                        <div><span>{cacheStore.GetString("DateofBirthLabel")}</span> <strong>{person.GetFormattedDateOfBirth()} ({person.GetFormattedAge()}) </strong></div>
                    </div>
                </div>

                <div style={{ marginBottom: "5px" }}>
                    <div>
                        <h5 className="uppercase" />
                        <ul className="phone-list">
                            {person.Phones?.map((phone, index) => (
                                <li key={phone.ContactPoint_id}>
                                    <div> <span className="myle-icon-16 phone" />{person.GetFormattedPhone(index)}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        <h5 className="uppercase">{cacheStore.GetString("AddressLabel")}</h5>
                        <ul className="phone-list">
                            {person.Addresses?.map((address, index) => (
                                <li key={address.ContactPoint_id}>
                                    <div><strong>{person.GetFormattedAddress(index)}</strong></div>
                                    <div><strong>{person.GetFormattedProvince() + " - " + person.GetFormattedCountry() + ", " + person.GetFormattedZipCode()}</strong></div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        <h5 className="uppercase">{cacheStore.GetString("EmailLabel")}</h5>
                        <div>
                            {person.Emails?.map((email, index) => (
                                <span key={email.ContactPoint_id} className="bl">
                                    {person.GetFormattedEmail(index)}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderRight(): JSX.Element {
        return (
            <div className="portal-search-panel">
                <div className="portal-patients-results" style={{ height: "100%" }}>
                    <div className="pa-selected-items-list ">
                        {this.state.apexPatientResult && this.state.apexPatientResult.map((apexP, idx) => {
                            let apexFirstName = (apexP.NOMBRE + " " + apexP.SEGUNDO_NOMBRE);
                            apexFirstName = apexFirstName.toUpperCase();

                            let address = [apexP.DESC_ESTADO, apexP.DESC_PAIS, apexP.CODIGO_POSTAL].filter(x => !!x).join(", ");
                            let sex = apexP.SEXO == ApexGenderEnum.F ? "female" : "male";
                            let selected = this.state.selectedPatientId == apexP.ID_PERSONA ? "selected" : "notselected";
                            let DDN = apexP.FECHA_NAC ? moment(apexP.FECHA_NAC).format("YYYY/MM/DD") : "";

                            return (
                                <div className={"flex-container selectable " + selected} onClick={() => this.mutateState(s => s.selectedPatientId = apexP.ID_PERSONA)} key={"apexPatient_" + idx} style={{ justifyContent: "flex-start" }}>

                                    <div>
                                        <img title="" src={img_p_banner_icon_100} style={{ width: "48px" }} alt="" />
                                    </div>
                                    <div style={{ marginLeft: "15px" }}>
                                        <h4 className="light-blue" style={{ fontSize: "18px" }}>
                                            <span>{apexFirstName}</span><span className={"myle-icon-16 " + sex} />
                                        </h4>
                                        <ul>
                                            <li><strong>Paterno </strong><span>{apexP.APELLIDO_PATERNO}</span></li>
                                            <li><strong>Materno </strong><span>{apexP.APELLIDO_MATERNO}</span></li>
                                            <li><strong>{sessionStore.getDefaultHealthCardLabel()} </strong><span>{apexP.CURP}</span></li>
                                            <li><strong>{cacheStore.GetString("FileNumbersLabel")} </strong><span>{apexP.ID_PERSONA}</span></li>
                                            {apexP.FECHA_NAC &&
                                                <li><strong>{cacheStore.GetString("DateofBirthLabel")} </strong> <span>{DDN}</span></li>
                                            }
                                            {address &&
                                                <li><span className="myle-icon-16 pin" /><span className="content-text ">{address}</span></li>
                                            }
                                        </ul>

                                    </div>
                                </div>
                            );
                        })}

                        {this.state.isLoading &&
                            <img src={img_loading} style={{ marginTop: "27%", marginLeft: "46%" }} alt="loading" />
                        }
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(Mutation: (s: ApexExternalSearchPopupState) => void): void {
        var state = new ApexExternalSearchPopupState();
        Mutation(state);
        this.setState(state);
    }

    private onAttachAccountClick(): void {
        let self = this;
        let ApexResult = this.state.apexPatientResult.filter(x => x.ID_PERSONA == this.state.selectedPatientId)[0];
        let requestDTO = {
            PatientContactId: this.props.person.ContactId,
            PatientCharNumber: cacheStore.ApexInterfaceCode + this.state.selectedPatientId,
            FatherLastName: !IsNullOrWhiteSpace(ApexResult.APELLIDO_PATERNO) ? ApexResult.APELLIDO_PATERNO : null, // Do not update if empty, send null to skip
            MotherLastName: !IsNullOrWhiteSpace(ApexResult.APELLIDO_PATERNO) ? ApexResult.APELLIDO_MATERNO : null // Do not update if empty, send null to skip
        };

        Client.Post(
            ServerOperations.Server.Myle_UpdatePatientChartNumberAndIdentifier01,
            requestDTO,
            () => {
                patientStore.ActionsProfile.loadPatient(this.props.person.ContactId);
                self.props.onCloseCallback();
            }
        );
    }
}

export { ApexExternalSearchPopup };
